<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String
    },
    input: {
      type: String
    }
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    this.keyboard = new Keyboard(this.keyboardClass, {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      layout: {
        default: [
          "1 2 3 4 5 6 7 8 9 0 ° +",
          "a z e r t y u i o p ^ $",
          "q s d f g h j k l m ù *",
          "w x c v b n , ; : !",
          "{shift} {space} {bksp}"
        ],
        shift: [
          "& é \" ' ( - è _ ç à ) =",
          "A Z E R T Y U I O P ¨ £",
          "Q S D F G H J K L M % µ",
          "W X C V B N ? . / §",
          "{shift} {space} {bksp}"
        ]
      },
      display: {
        "{bksp}": "Effacer",
        "{shift}": "Maj",
        "{space}": "Espace"
      }
    });
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);
    },
    onKeyPress(button) {
      this.$emit("onKeyPress", button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>

<style scoped>
.simple-keyboard {
  position: fixed;
  bottom: 16px;
  left: 380px;
  /* $size-module-width */
  right: 0;
  margin: 0 auto;
  max-width: calc(100vw - 380px - 32px);
  z-index: 10001;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}
</style>
